import { render, staticRenderFns } from "./contactRequests.vue?vue&type=template&id=0056cd1b"
import script from "./contactRequests.vue?vue&type=script&lang=js"
export * from "./contactRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports